import React from 'react'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
import { useApiFormNode } from '../../../../../api-new/state/content'
import { useApiListNode } from '../../../../../api-new/state/content'
import { Route, useRouteMatch } from 'react-router-dom'
import { Purge } from '../../../../../shared/page/page-purge'
import { IconRecycle } from '../../../../../shared/icon/icon'
import { ColumnSelector, ColumnText, ColumnMenu } from '../../../../../shared/table-builder/table-columns'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export const NodeRecycle = () => {
  const { url } = useRouteMatch()

  const apiListNode = useApiListNode()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListNode.get('deleted')
  const handleDestroyed = () => apiListNode.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListNode.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That node was already removed.'), err)
    }
    await apiListNode.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconRecycle} text="recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListNode} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnSelector field="metaData" header="Type" selector={row => (row.metaData ? JSON.parse(row.metaData.toLowerCase()).datatype : '')} />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:purgeID/purge`}>
        <Purge useApiForm={useApiFormNode} titleParam="name" successPath={`${url}`} />
      </Route>
    </React.Fragment>
  )
}
